import React, { useRef } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Portal } from '@vio/atlas/helpers/Portal';
import { Icon } from '@vio/atlas/Icon';
import useBodyScrollLock from '@vio/atlas/Overlay/useBodyScrollLock';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wxky6w8",
  propsAsIs: false
});
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h4fs3g5",
  propsAsIs: false
});
const HeaderContainer = /*#__PURE__*/styled('div')({
  name: "HeaderContainer",
  class: "h1ujrny7",
  propsAsIs: false
});
const CloseButton = /*#__PURE__*/styled('div')({
  name: "CloseButton",
  class: "cu3mlcw",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "cw88dwa",
  propsAsIs: false
});
const OverlayContent = ({
  children
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useBodyScrollLock({
    ref,
    isEnabled: true
  });
  return <ContentWrapper ref={ref}>{children}</ContentWrapper>;
};
interface Props {
  isOpen: boolean;
  header: React.ReactNode;
  onClose: () => void;
}
export const DestinationPickerPortal: React.FC<Props> = ({
  children,
  isOpen,
  onClose,
  header
}) => {
  return <Portal>
      <Wrapper className={cx(isOpen && '__isOpen')}>
        <HeaderWrapper>
          <HeaderContainer>{header}</HeaderContainer>
          <CloseButton onClick={onClose} data-id="OverlayPageCloseButton" data-testid="DestinationPickerPortalCloseButton">
            <Icon name="Close" />
          </CloseButton>
        </HeaderWrapper>
        {isOpen && <OverlayContent>{children}</OverlayContent>}
      </Wrapper>
    </Portal>;
};

require("./DestinationPickerPortal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DestinationPickerPortal.tsx");